import React from 'react';
import { SCHOOL_NAME } from '../../common/data/siteConfig';
import LogoPicture from '../../../images/logo.webp';
import Icon from '@mdi/react';
import { mdiAlphaSCircle } from '@mdi/js';

export default function SchoolTitle({ children, title, demo }) {
  return (
    <div className='media'>
      <div className='media-content'>
        <div className='content'>
          <div className='has-text-centered mb-5 flex flex-column justify-center align-center'>
            {demo ? (
              <div
                style={{
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 140,
                  height: 140,
                  backgroundColor: '#d3e8ff',
                }}
              >
                <Icon
                  path={mdiAlphaSCircle}
                  size={8}
                  color='var(--bg-side-menu)'
                />
              </div>
            ) : (
              <img
                alt='profile-pic'
                src={LogoPicture}
                style={{
                  width: 60,
                  height: 'auto',
                }}
              />
            )}
            <p className='mt-3'>
              <span className='has-text-weight-bold is-size-4'>
                {demo ? 'SKOOLAS PORTAL' : SCHOOL_NAME}
              </span>
              <br />
              <span className='is-size-6'>{title}</span>
            </p>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
